export const getMatchLocalDate = (date, includeYear = true, dateSlash = false) => {
    if (!date) {
        return { matchDate: "", matchTime: "" };
    }

    const adjustedTime = new Date(date);

    if (isNaN(adjustedTime.getTime())) {
        return { matchDate: "", matchTime: "" };
    }

    const options = {
        day: '2-digit',
        month: '2-digit',
        year: includeYear ? 'numeric' : undefined,
    };

    let matchDate = adjustedTime.toLocaleDateString('es-ES', options);

    if (!dateSlash) {
        matchDate = matchDate.replace(/\//g, '-');
    }

    const matchTime = adjustedTime.toLocaleTimeString('es-ES', {
        hour: '2-digit',
        minute: '2-digit',
        hour12: false,
    });

    return { matchDate, matchTime };
};

export const dateInverted = (date) => {
    if(date){
        var splitDate = date.split("-");
        var dia = splitDate[0];
        var mes = splitDate[1];
        var año = splitDate[2];

        return año + "-" + mes + "-" + dia;
    }
    return "";
}

export const setFullDate = (date, time) => {
    if (!date && !time) {
        return "";
    }

    if (date) {
        date = date.replace("Z", "");
        date += "T";
    }

    if (time && !time.includes("Z")) {
        time += "Z";
    }

    return date + time;
};

export const formatShortDate = (dateInput) => {
    if (!dateInput) return null;

    const [day, month, year] = dateInput.split('-');
    const isoDate = `${year}-${month}-${day}`;
    const dateObj = new Date(isoDate);

    if (isNaN(dateObj.getTime())) return null;

    const months = [
        "Ene", "Feb", "Mar", "Abr", "May", "Jun",
        "Jul", "Ago", "Sep", "Oct", "Nov", "Dic"
    ];

    const monthIndex = dateObj.getMonth(); // 0 = enero
    return `${day} ${months[monthIndex]}`;
};